export default __webpack_public_path__ + "static/media/noise_low_light.ea924821.svg";